// extracted by mini-css-extract-plugin
export default {"overlay":"Popup_overlay__Rlo3p","modal":"Popup_modal__oHjOC","header":"Popup_header__OUiwq","close":"Popup_close__eT9CH","body":"Popup_body__SDEiw"};